import { Config } from '@leverege/plugin';
import semver from 'semver';
import C from '../locatorReconciliation/Constants';
export function isPositionRequestableByBusinessStateAndConfig(locator) {
  const pairedPositionSupportedConfigs = Config.get('PositionRequest', 'pairedPositionSupportedConfigs', []);
  const toReturn = locator?.data?.businessState === C.BUSINESS_STATES.SUPPORT_REQUIRED || locator?.data?.businessState === C.BUSINESS_STATES.AVAILABLE || locator?.data?.businessState === C.BUSINESS_STATES.SUSPECTED_OFF_LOT || locator?.data?.businessState === C.BUSINESS_STATES.PAIRED && pairedPositionSupportedConfigs.includes(locator?.data?.reportedStateSpecificConfigKeystreamId);
  return toReturn;
}

// keeping this for old, usually broken locators on testing that dont report a config version number
export function isPositionRequestableByOperationStateAndConfig(locator) {
  const pairedPositionSupportedConfigs = Config.get('PositionRequest', 'pairedPositionSupportedConfigs', []);
  const toReturn = locator?.data?.reportedOperationState === C.OPERATION_STATES.LM_IDLE || locator?.data?.reportedOperationState === C.OPERATION_STATES.TR_IDLE || locator?.data?.reportedOperationState === C.OPERATION_STATES.LM_ACTIVE && pairedPositionSupportedConfigs.includes(locator?.data?.reportedStateSpecificConfigKeystreamId);
  return toReturn;
}
export function isPositionRequestableByStateConfigVersionNumber(locator) {
  const locatorData = locator?.data?.data ? locator?.data?.data : locator?.data;
  const reportedStateSpecificConfigVersion = locatorData?.reportedStateSpecificConfigVersion;
  if (!reportedStateSpecificConfigVersion) {
    console.log('No reported state specific config version number from locator');
    return false;
  }
  // validates state specific config version and trims it to just numbers
  const stateConfigSemanticVersion = semver.valid(semver.coerce(reportedStateSpecificConfigVersion, {
    loose: true
  }));
  if (!stateConfigSemanticVersion) {
    console.log('Invalid locator for conversion, cannot validate config requirement');
    return false;
  }

  // if locator is unpaired
  if (locatorData?.reportedOperationState === C.OPERATION_STATES.LM_IDLE || locatorData?.reportedOperationState === C.OPERATION_STATES.TR_IDLE) {
    return semver.satisfies(stateConfigSemanticVersion, `>=${C.STATE_CONFIG_VERSIONS.UNPAIRED}`);
  }
  // if locator is paired
  if (locatorData?.reportedOperationState === C.OPERATION_STATES.LM_ACTIVE) {
    return semver.satisfies(stateConfigSemanticVersion, `>=${C.STATE_CONFIG_VERSIONS.PAIRED}`);
  }
  // otherwise return false if the locator is not in any of those operation states
  return false;
}